/* ---------------------------------------------------------------------------
 * MD Fashionwear — fresh "You may also love" every time the drawer opens
 *
 * TWO REQUIREMENTS THAT LOOK CONTRADICTORY, AND HOW THEY COEXIST
 *   1. Adding an item must NOT reshuffle the carousel. Solved by md-cart-store
 *      and md-cart-hydrate, which keep the chosen set and rebuild it after the
 *      theme replaces the drawer.
 *   2. Opening the drawer SHOULD show a different mix each time.
 *
 * Both hold if the reroll happens on OPEN and nothing else: stable for as long as
 * the drawer stays open, new selection next time it is opened.
 *
 * THE OLD SET STAYS ON SCREEN WHILE THE NEW ONE LOADS. The saved set is not
 * cleared up front — the catalogue walk takes a second or two, and clearing first
 * would leave a blank block, which is the bug that was reported earlier. The
 * cards are swapped only once the replacements are in hand.
 *
 * Lebanon always gets both kinds: MDCartPool guarantees a minimum of in-stock AND
 * preorder before it stops walking pages, then interleaves them and round-robins
 * across product types, so a row is dresses AND shoes AND bags AND accessories.
 *
 * The observer here is limited to the open attribute on the drawer. It does not
 * watch child nodes, so it cannot fall into the repaint loop that froze the tab
 * when an earlier version watched the whole document.
 * ------------------------------------------------------------------------- */

(function () {
  'use strict';

  var NEED = 60;
  var SHOW = 24;
  var wasOpen = false;
  var busy = false;
  var lastRoll = 0;

  function drawer() {
    return document.getElementById('cart-drawer');
  }

  function isOpen(el) {
    if (!el) return false;
    if (el.hasAttribute('open')) return true;
    return el.getAttribute('aria-hidden') === 'false';
  }

  function reroll() {
    if (busy) return;
    if (Date.now() - lastRoll < 1200) return;      // ignore attribute chatter
    if (!window.MDCartPool || !window.MDCartRecs || !window.MDCartRecs.buildFrom) return;

    busy = true;
    lastRoll = Date.now();

    var worldwide = window.MDCartRecs.market() !== 'LB';

    fetch('/cart.js')
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .catch(function () { return { items: [] }; })
      .then(function (cart) {
        var inCart = ((cart && cart.items) || []).map(function (i) { return String(i.product_id); });
        return window.MDCartPool.gather({
          worldwide: worldwide,
          inCart: inCart,
          excluded: {},        // a new visit to the drawer, nothing withheld
          need: NEED
        });
      })
      .then(function (products) {
        // Only swap once there is something to swap in.
        if (products && products.length) {
          window.MDCartRecs.buildFrom(products.slice(0, SHOW), products.slice(SHOW), {});
        }
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function watch(el) {
    if (!el || el.__mdRoll) return;
    el.__mdRoll = true;

    wasOpen = isOpen(el);

    if (window.MutationObserver) {
      new MutationObserver(function () {
        var now = isOpen(el);
        if (now && !wasOpen) reroll();     // closed -> open
        wasOpen = now;
      }).observe(el, { attributes: true, attributeFilter: ['open', 'aria-hidden', 'class'] });
    }
  }

  function boot() {
    var tries = 0;
    (function attempt() {
      var el = drawer();
      if (el) { watch(el); return; }
      if (tries++ > 40) return;
      setTimeout(attempt, 200);
    })();

    // Clicking the cart icon is the usual way in; catch it directly too, in case
    // the theme opens the drawer without changing any of the watched attributes.
    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;
      if (event.target.closest('.header__cart-link, [aria-controls="cart-drawer"]')) {
        setTimeout(reroll, 250);
      }
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.MDCartReroll = { reroll: reroll };
})();
